import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../../components/common/Footer";
import Tabs from "../../components/common/Tabs";

const tabs = [
  {
    link: "/reporting/reports",
    title: "Reports",
  },
  {
    link: "/reporting/scheduled-reports",
    title: "Scheduled Reports",
  },
  {
    link: "/reporting/metrics_pricing",
    title: "Metrics",
  },
  {
    link: "/reporting/surveys",
    title: "Surveys",
  },
];

function Reporting() {
  return (
    <div className="page-container">
      <div className="main-container">
        <Tabs tabs={tabs} keepFirstLinkActive={true}/>
        <Outlet />
        {/* Footer  */}
        <Footer />
      </div>
    </div>
  );
}

export default Reporting;
